

















































import { ciFacebook } from '~/icons/source/solid/facebook'
import { ciInstagram } from '~/icons/source/solid/instagram'
import { SocialMediaLinks } from '~/models/dealer/types'
import { ciX } from '~/icons/source/brand/x'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { ciYoutube } from '~/icons/source/solid/youtube'

export default defineComponent({
  props: {
    socialMedia: {
      type: Object as PropType<SocialMediaLinks>,
      required: true
    }
  },
  data: () => ({
    icons: {
      facebook: ciFacebook,
      instagram: ciInstagram,
      youtube: ciYoutube,
      x: ciX
    }
  })
})
